import React, { useState, useEffect, Fragment } from "react";
import { Typography, Switch, Box, makeStyles } from "@material-ui/core";

//images
import PROPRE from "../../../../../images/pictos-ok/SUPER PROPRE.svg";
import SALE from "../../../../../images/pictos-ok/SALE.svg";

const useStyles = makeStyles((theme) => ({
  inputRange: {
    marginTop: 75,
    transform: "rotate(270deg)",
  },
}));

const Step1 = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState({
    presence: false,
  });

  useEffect(() => {
    // Quand le composant se charge, n'autorise pas à passer à la suite
    props.setAuthorization(false);
    // Insérer les réponses par défaut des switch dans la réponse
    for (let element in value) {
      props.result[element] = value[element];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant local
    setValue({ ...value, [event.target.name]: event.target.checked });
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult[event.target.name] = event.target.checked;
    props.setResult(newResult);
  };

  const handleRangeChange = (event) => {
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["proprete"] = event.target.valueAsNumber;
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
  };

  return (
    <Fragment>
      <Typography variant="body1" component="legend" style={{ marginLeft: 20 }}>
        J'indique la présence ou le manque, la propreté ...
      </Typography>
      <Box
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Manque
        </Typography>
        <Switch
          name="presence"
          checked={value.presence}
          onChange={handleChange}
        />
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Présence
        </Typography>
      </Box>
      <Box
        style={{
          display: "flex",
          marginTop: 30,
          marginBottom: "8vh",
          minHeight: 160,
        }}
      >
        <form>
          <input
            name="proprete"
            type="range"
            className={classes.inputRange}
            min="0"
            max="100"
            onChange={handleRangeChange}
          />
        </form>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            Super propre <br />
            <img src={PROPRE} alt="Super propre" width="70" />
          </Typography>
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            Sale <br />
            <img src={SALE} alt="Super propre" width="70" />
          </Typography>
        </Box>
      </Box>
    </Fragment>
  );
};

export default Step1;
